import { render, staticRenderFns } from "./new-claim-ticket.vue?vue&type=template&id=2d12bab7&scoped=true&"
import script from "./new-claim-ticket.vue?vue&type=script&lang=js&"
export * from "./new-claim-ticket.vue?vue&type=script&lang=js&"
import style0 from "./new-claim-ticket.vue?vue&type=style&index=0&id=2d12bab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12bab7",
  null
  
)

export default component.exports